import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-9efb0684"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "content-side" };
import Empty from './components/Empty';
import Chat from './components/Chat/Chat';
import Recipients from './components/ChatRecipients';
import { computed } from 'vue';
import { ChatStore } from '@common/stores';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContentSide',
    setup: function (__props) {
        var contentSection = computed(function () { return ChatStore.contentSection; });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (contentSection.value === 'empty')
                    ? (_openBlock(), _createBlock(_unref(Empty), { key: 0 }))
                    : (contentSection.value === 'chat')
                        ? (_openBlock(), _createBlock(_unref(Chat), { key: 1 }))
                        : (contentSection.value === 'chat-recipients')
                            ? (_openBlock(), _createBlock(_unref(Recipients), { key: 2 }))
                            : _createCommentVNode("", true)
            ]));
        };
    }
});
